import BillingInvoiceItem from 'app/shared/model/BillingInvoiceItem';
import BillingInvoicePayment from 'app/shared/model/BillingInvoicePayment';

const BillingInvoice = ({
    amount = 0,
    balance = 0,
    dueDate = null,
    invoiceDate = null,
    invoiceItems = [],
    invoiceNumber = '',
    accountName = '',
    accountNumber = '',
    lastZuoraSyncTime = '',
    propertyNames = [],
    totalAccountBalance = null,
    invoiceType = '',
    payments = [],
    accountAutopay = false,
    invoiceId = '',
    isPaymentInProgress = '',
    canMakePayments = false,
} = {}) => ({
    amount: Number(amount),
    balance: Number(balance),
    dueDate: String(dueDate),
    invoiceDate: String(invoiceDate),
    invoiceItems: invoiceItems.map(BillingInvoiceItem),
    invoiceNumber: String(invoiceNumber),
    accountName: String(accountName),
    accountNumber: String(accountNumber),
    lastZuoraSyncTime: String(lastZuoraSyncTime),
    propertyNames: propertyNames.map(String),
    totalAccountBalance,
    invoiceType: String(invoiceType),
    payments: payments.map(BillingInvoicePayment),
    accountAutopay: Boolean(accountAutopay),
    invoiceId: String(invoiceId),
    isPaymentInProgress: Boolean(isPaymentInProgress),
    canMakePayments: Boolean(canMakePayments),
});

export default BillingInvoice;
